<!-- Modal.svelte -->
<script>
    let { params } = $props();

    function goTo() {
        window.location.href = params.link;
    }
</script>

<div class="noData">
    <i class="noData__icon fal {params.icon}"></i>
    <span>
        <h3>{params.title}</h3>
        <p>{params.description}</p>
    </span>
    {#if params.button}
        <button onclick={goTo} class="--black">{params.button}</button>
    {/if}
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
